import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { EventData } from '@core/tellent-assistant-types';

import { ListCardComponent } from '../../list-card/list-card.component';
import { ListRowPersonComponent } from '../../rows/list-row-person.component';

function formatEventInterval(startsAtIso: string, duration?: number | null): string {
  const start = new Date(startsAtIso);
  const dayLabel = start.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  const startTime = start.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
  if (!duration) {
    return `${dayLabel} • ${startTime}`;
  }
  const end = new Date(start.getTime() + duration * 60_000);
  const endTime = end.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${dayLabel} • ${startTime} - ${endTime}`;
}

@Component({
  selector: 'rt-list-item-event',
  imports: [ListCardComponent, ListRowPersonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-event.component.html',
  styleUrl: './list-item-event.component.less',
})
export class ListItemEventComponent {
  protected readonly interval = computed(() =>
    formatEventInterval(this.data().startsAt, this.data().duration),
  );

  public readonly data = input.required<EventData>();
}
